import React from "react";
import { Building2, Users, Presentation, Calendar, Award } from "lucide-react";
import LeadForm from "../components/LeadForm";
import Seo from "../components/Seo";

export default function Corporate() {
  return (
    <div className="pt-24 lg:pt-28">
      <Seo title="Corporate Travel & MICE" path="/corporate" description="Corporate travel management and MICE events — team offsites, conferences, incentive trips. 300+ corporate clients, dedicated relationship managers." />
      <section className="container-p grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div>
          <span className="section-label">Corporate Travel & MICE</span>
          <h1 className="h1 mt-3">Business travel, done right.</h1>
          <p className="muted mt-5 text-lg">From C-suite offsites to 500-person conferences — we handle logistics, negotiations and on-ground coordination so your team can focus on outcomes.</p>
          <div className="grid grid-cols-2 gap-6 mt-8">
            {[
              { icon: Users, k: "300+", v: "Corporate Clients" },
              { icon: Presentation, k: "50+", v: "MICE Events / Year" },
              { icon: Calendar, k: "24×7", v: "Dedicated RM" },
              { icon: Award, k: "15%", v: "Avg. Cost Savings" },
            ].map(s => (
              <div key={s.v} className="flex gap-3">
                <s.icon className="w-8 h-8 text-[#FF7D00]" strokeWidth={1.5} />
                <div><div className="font-display font-bold text-2xl text-[#0A2540]">{s.k}</div><div className="text-sm muted">{s.v}</div></div>
              </div>
            ))}
          </div>
        </div>
        <div className="relative aspect-[4/3] rounded-3xl overflow-hidden"><img src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=1200&q=80" alt="Corporate travel" className="w-full h-full object-cover" /></div>
      </section>

      <section className="section container-p">
        <h2 className="h2 mb-10">Services we cover</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { icon: Building2, title: "Business Travel", d: "Corporate flight bookings, hotel deals, ground transport across 150+ cities." },
            { icon: Presentation, title: "MICE", d: "Meetings, Incentives, Conferences, Exhibitions — end-to-end MICE management." },
            { icon: Users, title: "Group Bookings", d: "Team offsites, sales incentive trips, dealer tours — customized for any group size." },
          ].map(s => (
            <div key={s.title} className="card-glass p-8"><s.icon className="w-8 h-8 text-[#006CE4] mb-4" strokeWidth={1.5} /><h3 className="h3 mb-2">{s.title}</h3><p className="muted text-sm">{s.d}</p></div>
          ))}
        </div>
      </section>

      <section className="container-p pb-20"><div className="card-glass p-8 md:p-12"><LeadForm title="Request a Corporate Proposal" source="corporate" /></div></section>
    </div>
  );
}
